import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Base from "./Base";
var Success = function Success(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Base, {
    type: "success"
  }, children);
};
Success.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
export default /*#__PURE__*/memo(Success);